/**
 * Returns the URL only if it is a safe http(s) image source, else an empty
 * string. Blocks `javascript:`, `data:`, `vbscript:` and other schemes that
 * could be injected via merchant-controlled product image URLs (defense in
 * depth before passing untrusted data to an <img src>).
 */
export function safeImageUrl(url?: string | null): string {
  if (!url) return '';
  const trimmed = url.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : '';
}
